/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_SupportInputs */

const en_nav_support = /** @type {(inputs: Nav_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const de_nav_support = /** @type {(inputs: Nav_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hilfe`)
};

const fr_nav_support = /** @type {(inputs: Nav_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistance`)
};

const es_nav_support = /** @type {(inputs: Nav_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soporte`)
};

const it_nav_support = /** @type {(inputs: Nav_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supporto`)
};

const nl_nav_support = /** @type {(inputs: Nav_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ondersteuning`)
};

const pl_nav_support = /** @type {(inputs: Nav_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomoc`)
};

const fi_nav_support = /** @type {(inputs: Nav_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuki`)
};

const da_nav_support = /** @type {(inputs: Nav_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const sv_nav_support = /** @type {(inputs: Nav_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

/**
* | output |
* | --- |
* | "Support" |
*
* @param {Nav_SupportInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const nav_support = /** @type {((inputs?: Nav_SupportInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_SupportInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_support(inputs)
	if (locale === "fr") return fr_nav_support(inputs)
	if (locale === "es") return es_nav_support(inputs)
	if (locale === "it") return it_nav_support(inputs)
	if (locale === "nl") return nl_nav_support(inputs)
	if (locale === "pl") return pl_nav_support(inputs)
	if (locale === "fi") return fi_nav_support(inputs)
	if (locale === "da") return da_nav_support(inputs)
	if (locale === "sv") return sv_nav_support(inputs)
	return en_nav_support(inputs)
});